
import { isEmpty } from "@utils";

export default {
	name: "SortBySelector",
	props: {
		options: {
			type: Object,
			required: true,
		},
		labelOverride: {
			type: String,
			required: false,
			default: null,
		},
		currentSort: {
			type: String,
			required: true,
		},
		hintText: {
			type: String,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			open: false,
			tabindex: 0,
		};
	},
	computed: {
		selected() {
			return this.currentSort || "score";
		},

		labelText() {
			if (
				typeof this.labelOverride === "string" &&
				this.labelOverride.length
			) {
				return this.labelOverride;
			}

			return this.selected.text;
		},
		hasHint() {
			return !isEmpty(this.hintText);
		},
	},
	methods: {
		toggleOpen() {
			this.open = !this.open;
			this.$emit("toggle", this.open);
		},
		checkOption(option) {
			this.open = false;
			this.$emit("change", option.key);
		},
	},
};
